import React, { FC } from "react";
import { ComponentsLocalization } from "../../../types/graphql/generated";
import { StyledCopyright } from "./index.styled";

export interface FooterCopyrightProps {
  brandName: string;
  localization: ComponentsLocalization["footer"];
}

export const Copyright: FC<FooterCopyrightProps> = ({
  brandName,
  localization,
}) => {
  const year = new Date().getFullYear();
  const { allRightsReserved } = localization || {};

  return (
    <StyledCopyright data-testid="footer-copyright">
      © {year} {brandName}. {allRightsReserved}
    </StyledCopyright>
  );
};
